<template>
  <div class="work__panel__next" :class="{ 'is-visible': progress >= 95 }">
    <div>
      <span class="mask fs-12 ff-mono c-text-alt" :style="{ '--index': 1 }">
        <span class="word">
          {{ renderIndex(nextProject?.work?.index + 1, 2) }}
        </span>
      </span>
    </div>
    <div>
      <span class="mask fs-12 ff-mono tt-u" :style="{ '--index': 1 }">
        <span class="word">Next</span>
      </span>
    </div>

    <div>
      <span
        class="mask fs-12 ff-mono c-text-alt tt-u"
        :style="{ '--index': 2 }"
      >
        <span class="word">Project</span>
      </span>
    </div>

    <div class="fs-14 tt-u">
      <div class="mask" :style="{ '--index': 2 }">
        <span class="word">
          {{ nextProject?.work?.data?.name }}
        </span>
      </div>
      <div class="mask" :style="{ '--index': 3 }">
        <span class="word"> {{ nextProject?.work?.data?.role }} </span>
      </div>
      <div class="mask" :style="{ '--index': 4 }">
        <span class="word"> {{ nextProject?.work?.data?.year }} </span>
      </div>
    </div>

    <NuxtLink
      class="work__panel__next__media"
      :to="`/works/${nextProject?.work?.uid}`"
    >
      <AppMedia :src="nextProject?.work?.data?.image?.url"
    /></NuxtLink>

    <NuxtLink
      class="work__panel__next__link"
      :to="`/works/${nextProject?.work?.uid}`"
    >
      <ClientOnly>
        <div class="mask" :style="{ '--index': 7 }">
          <AppLink
            class="word ta-r tt-u"
            :class="{ 'fs-12': !$mq.isMobile, 'fs-48': $mq.isMobile }"
            :underline="true"
          >
            Go Next
          </AppLink>
        </div>
      </ClientOnly>
    </NuxtLink>
  </div>
</template>

<script setup>
const { $Lenis, $mq } = useNuxtApp();
const progress = ref(0);

const props = defineProps({
  nextProject: { type: Object, default: null },
});

onMounted(() => {
  $Lenis.core.on('scroll', e => {
    progress.value = Math.floor(e.progress * 100);
  });
});
</script>

<style lang="scss" scoped>
.work__panel__next {
  aspect-ratio: 1/0.7;
  background: rgba(30, 30, 30);
  border-radius: var(--radius);
  // border-radius: var(--radius);
  bottom: 0;
  bottom: var(--offset-half);
  color: var(--c-text-alt);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-width: var(--col-4);
  padding: var(--offset);
  position: fixed;
  right: var(--offset-half);
  transform: translate3D(0, calc(100% + var(--offset-half)), 0);
  transition: transform 0.5s ease(outExpo);
  width: calc(col(1) + var(--offset));
  will-change: transform, clip-path;
  z-index: layer(overlay);

  //

  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: var(--gutter);

  @include mqDown(desktop) {
    display: none;
  }

  @include mq(desktop) {
    min-width: 40rem;
  }

  &.is-visible {
    transform: translate3D(0, 0, 0);
    // clip-path: inset(0% round var(--radius));
    transition: transform 1s ease(smooth);
  }
}

.work__panel__project {
  display: flex;
  flex-direction: column;
  gap: var(--gutter);
}

.work__panel__back {
  display: flex;
  align-items: center;
  gap: var(--gutter);
}

.work__panel__next__media {
  width: 50%;
  align-self: end;
  clip-path: inset(50%);
  cursor: pointer;

  .is-visible & {
    clip-path: inset(0%);
    transition: clip-path 1.5s ease(outExpo) 0.75s;
  }
}

.work__panel__next__link {
  align-self: end;
}

.mask {
  clip-path: inset(0%);
}

.word {
  transform: translateY(105%);
  display: inline-block;

  .is-visible & {
    transform: translateY(0%);
    transition: transform 1s ease(outExpo) calc((var(--index) * 0.1s) + 0.25s);
  }
}
</style>
